import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';
// import { GoogleMapService } from '../../_shared/services/google-map.service';

import { Zone } from '../shared/zone.model';
import { ZoneModalService } from '../shared/zone-modal.service';
import { ZoneService } from '../shared/zone.service';

import { LocationService } from '../../locations/shared/location.service';
import { LocationModalService } from '../../locations/shared/location-modal.service';
import { PickupPlaceModalService } from '../../pickup-places/shared/pickup-place-modal.service';

@Component({
  selector: 'app-zone-detail',
  templateUrl: './zone-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class ZoneDetailComponent implements OnInit {
  @Input() zone: Zone;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedZone = new EventEmitter<Zone>();
  @Output() private canceledZone = new EventEmitter();

  form: FormGroup;
  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  loadingLocations = false;
  locations = [];

  zonePickUpPlaces = [];

  serverErrors = [];
  sendingForm = false;

  private zoneCopy = null;

  googleMapLoaded = false;

  constructor(
    private zoneService: ZoneService,
    private zoneModalService: ZoneModalService,
    private locationService: LocationService,
    private locationModalService: LocationModalService,
    private pickupPlaceModalService: PickupPlaceModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    public utilService: UtilService // private googleMapService: GoogleMapService
  ) {
    // this.googleMapService.loadGoogleMapScript().then(() => {
    //   this.googleMapLoaded = true;
    // });
  }

  ngOnInit() {
    this.setZoneForm();

    if (this.zone.id) {
      this.setItemOptions(this.zone, this.mode);

      this.form.patchValue(this.zone);
    } else {
      this.createMode = true;
    }

    this.getLocations();
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language: any) {
    this.zoneModalService.openZoneTranslation(this.zone, language);
  }

  openLocationsModal() {
    const successCallback = () => {
      this.getLocations();
    };

    this.locationModalService.openLocationsModal(successCallback);
  }

  openPickupPlacesModal() {
    const successCallback = () => {
      this.getZone();
    };

    this.pickupPlaceModalService.openPickupPlacesModal(successCallback);
  }

  // Referenced from app-item-detail-form-actions
  onSavedZone() {
    this.formSubmited = true;

    if (this.form.invalid || this.locations.length === 0) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'description', 'location_ids'];

    if (this.editMode && !fields.some((field) => formData[field] !== this.zoneCopy[field])) {
      this.onCanceled();
      return;
    }

    this.sendingForm = true;

    // console.log(formData);
    // return;

    this.zoneService.saveZone(this.zone.id, formData, this.defaultLanguage.lang).subscribe({
      next: (response) => {
        let msg = '';

        if (this.editMode) {
          msg = 'ZONE_UPDATED';

          // needed if we want to keep the page opened or if used in page
          this.zone = response;
          this.setItemOptions(response);
        } else {
          msg = 'ZONE_CREATED';
          // this.zone = response; // reload item - needed ?

          // if (!this.isModal) {
          this.savedZone.emit(response);
          // }
        }

        this.alertService.open(msg);

        this.sendingForm = false;

        // if (this.isModal) {
        this.savedZone.emit(response);
        // }
      },
      error: (response) => {
        this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

        this.utilService.scrollToTop();

        this.sendingForm = false;
      },
    });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    if (this.editMode) {
      this.cancelEdit();
      return;
    }

    this.canceledZone.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedZone() {
    this.editMode = true;
    this.viewMode = false;

    // this.form.controls['location_ids'].enable();
  }

  private cancelEdit() {
    this.zone = this.zoneCopy;

    // this.form.controls['location_ids'].disable();

    this.setItemOptions(this.zone);
  }

  private setItemOptions(zone, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedZone();
    }

    this.setZonePickUpPlaces();

    this.zoneCopy = { ...zone };
  }

  private setZoneForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: '',
      location_ids: [null, Validators.required], // ''
    });

    // if (this.viewMode) {
    // this.form.controls['location_ids'].disable();
    // }
  }

  private getLocations() {
    const params = {
      get: 'active',
      skip_check_role: true,
      lang: this.defaultLanguage.lang,
    };

    this.loadingLocations = true;

    this.locationService.getLocations(params).subscribe((response) => {
      const locations = [...response];

      this.locations = this.locationService.groupLocations(locations); // , '', 'locations'

      this.loadingLocations = false;
    });
  }

  private setZonePickUpPlaces() {
    this.zonePickUpPlaces = this.zoneService.setZonePickUpPlaces(this.zone.pickup_places);
  }

  private getZone() {
    this.zoneService.getZone(this.zone.id, this.defaultLanguage.lang).subscribe((zone) => {
      this.zone.pickup_places = zone.pickup_places;
      this.setZonePickUpPlaces();

      // $rootScope.$broadcast('reloadItems', vm.itemPickUpPlaces); to uploa the map ?
    });
  }
}

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

this.form = this.formBuilder.group({
      name: [
        this.zone.name,
        {
          validators: [
            Validators.required,
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      description: [this.zone.description],
      location_ids: [this.zone.location_ids, Validators.required],
    });

*/
